import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateLoader, TranslateModule, TranslateService, TranslateStaticLoader} from 'ng2-translate/ng2-translate';
import {Http} from '@angular/http';

// import { ChangeLanguageModule } from './change-language.module';
@NgModule({
  imports: [
    CommonModule, TranslateModule
  ],
  declarations: [],
  exports: [TranslateModule]
})
export class SharedTranslationModule {
  static forRoot(): ModuleWithProviders {
    function translateLoader(http: Http) {
      return new TranslateStaticLoader(http, 'i18n', '.json');
    }

    return {
      ngModule: SharedTranslationModule,
      providers: [{
        provide: TranslateLoader,
        useFactory: translateLoader,
        deps: [Http]
      },
        TranslateService]
    };
  }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/change-language/shared-translation.module.ts